import { render, staticRenderFns } from "./renewalHistory.vue?vue&type=template&id=64ea5c9a&scoped=true"
import script from "./renewalHistory.vue?vue&type=script&lang=js"
export * from "./renewalHistory.vue?vue&type=script&lang=js"
import style0 from "./renewalHistory.vue?vue&type=style&index=0&id=64ea5c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea5c9a",
  null
  
)

export default component.exports